import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import LanguageContext from '../contexts/LanguageContext';
import { getTranslation } from '../services/languageService';
import Markdown from '../components/Markdown';
import './Blog.scss';

const Blog = () => {
  const { language } = useContext(LanguageContext);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  // Blog posts data focused on SME needs
  const blogPosts = [
    {
      id: 1,
      title: "How Malaysian SMEs Can Benefit from AI Solutions",
      excerpt: "Exploring practical AI applications that can transform small and medium enterprises in Malaysia, from inventory management to customer service.",
      date: "May 15, 2023",
      author: "Dr. Sarah Chen",
      category: "SME Solutions"
    },
    {
      id: 2,
      title: "E-Invoicing Compliance for Malaysian Businesses",
      excerpt: "A step-by-step guide to implementing compliant e-invoicing systems for Malaysian SMEs, including tax requirements and best practices.",
      date: "April 28, 2023",
      author: "Michael Rodriguez",
      category: "Compliance"
    },
    {
      id: 3,
      title: "5 Cost-Effective Automation Tools for Small Businesses",
      excerpt: "Discover affordable automation solutions that can significantly reduce operational costs while improving efficiency for Malaysian SMEs.",
      date: "April 10, 2023",
      author: "James Wilson",
      category: "Cost Savings"
    },
    {
      id: 4,
      title: "Choosing the Right ERP System for Your SME",
      excerpt: "Key factors Malaysian SMEs should consider when selecting an ERP system, including budget constraints and scalability needs.",
      date: "March 22, 2023",
      author: "Emma Thompson",
      category: "SME Guides"
    },
    {
      id: 5,
      title: "Digital Transformation Roadmap for Traditional Businesses",
      excerpt: "A practical guide for traditional Malaysian businesses looking to embrace digital transformation without breaking the bank.",
      date: "March 5, 2023",
      author: "Dr. Ahmad Kamal",
      category: "Transformation"
    }
  ];

  return (
    <motion.div
      className="blog"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <section className="section">
        <div className="container">
          <motion.h1 className="page-title text-center" variants={itemVariants}>
            {getTranslation('navigation.blog', language)}
          </motion.h1>
          
          <div className="blog-content">
            <div className="blog-posts">
              {blogPosts.map((post) => (
                <motion.article 
                  key={post.id} 
                  className="blog-post card"
                  variants={itemVariants}
                  whileHover={{ y: -5 }}
                >
                  <div className="post-header">
                    <span className="post-category">{post.category}</span>
                    <h2 className="post-title">{post.title}</h2>
                  </div>
                  
                  <div className="post-meta">
                    <span className="post-date">{post.date}</span>
                    <span className="post-author">by {post.author}</span>
                  </div>
                  
                  <Markdown className="post-excerpt">{post.excerpt}</Markdown>
                  
                  <div className="post-footer">
                    <button className="btn">
                      Read More
                    </button>
                  </div>
                </motion.article>
              ))}
            </div>
            
            <aside className="blog-sidebar">
              <motion.div className="sidebar-widget card" variants={itemVariants}>
                <h3 className="widget-title">Categories</h3>
                <ul className="category-list">
                  <li><button className="category-link">SME Solutions</button></li>
                  <li><button className="category-link">Compliance</button></li>
                  <li><button className="category-link">Cost Savings</button></li>
                  <li><button className="category-link">SME Guides</button></li>
                  <li><button className="category-link">Transformation</button></li>
                </ul>
              </motion.div>
              
              <motion.div className="sidebar-widget card" variants={itemVariants}>
                <h3 className="widget-title">Recent Posts</h3>
                <ul className="recent-posts">
                  {blogPosts.slice(0, 3).map((post) => (
                    <li key={post.id}>
                      <button className="recent-post-link">
                        <h4>{post.title}</h4>
                        <span className="post-date">{post.date}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </motion.div>
            </aside>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Blog;
